import PropTypes from 'prop-types';

const Toggle = ({ handleChange, checked, label }) => (
  <label
    className="relative inline-flex cursor-pointer items-center gap-2 text-sm font-semibold"
    data-testid="toggle-wrapper"
  >
    <input
      id="switch"
      type="checkbox"
      className="peer sr-only"
      checked={checked}
      onChange={handleChange}
    />
    <label htmlFor="switch" className="hidden"></label>
    <div className="peer h-6 w-11 rounded-full border bg-grey-500 after:absolute after:left-[2px] after:top-0.5 after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-purple-200 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:ring-green-300"></div>
    {label}
  </label>
);

Toggle.propTypes = {
  handleChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired
};

export default Toggle;
